import React from 'react'

export function Copyright({ className }: { className?: string }) {
  return (
    <span className={`pr-4 border-core-purple-40 ${className}`}>
      &#169; noissue {new Date().getFullYear()}
    </span>
  )
}
